/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Create_TitleInputs */

const cs_deals_create_title = /** @type {(inputs: Deals_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový obchod`)
};

const en_deals_create_title = /** @type {(inputs: Deals_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New deal`)
};

/**
* | output |
* | --- |
* | "New deal" |
*
* @param {Deals_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_create_title = /** @type {((inputs?: Deals_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_create_title(inputs)
	return cs_deals_create_title(inputs)
});